/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Pagination_PrevInputs */

const vi_common_pagination_prev = /** @type {(inputs: Common_Pagination_PrevInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trước`)
};

/**

* @param {Common_Pagination_PrevInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const common_pagination_prev = /** @type {((inputs?: Common_Pagination_PrevInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Pagination_PrevInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_common_pagination_prev(inputs)
});